import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { CookieList } from './CookieList'

export type CookieListBlockProps = SbBaseBlockProps<object>

export const CookieListBlock = ({ blok }: CookieListBlockProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <CookieList />
    </div>
  )
}
CookieListBlock.blockName = 'cookieList'
